import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FiUserViewProfileTabBase } from '@fi-app/user/fi-user-view-dialog/fi-user-view-profile-tab-group/fi-user-view-profile-tab-base';

@Component({
    selector: 'fi-user-view-profile-other-tab',
    templateUrl: './fi-user-view-profile-other-tab.component.html',
    styleUrls: ['./fi-user-view-profile-other-tab.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-user-view-profile-other-tab' },
    standalone: false,
})
export class FiUserViewProfileOtherTabComponent extends FiUserViewProfileTabBase {}
